import { ref, computed } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-292769ed"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "query-time-cell"
};
const _hoisted_2 = {
  class: "cell-display"
};
const _hoisted_3 = {
  class: "time-editor-popover"
};
const _hoisted_4 = {
  class: "popover-header"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "popover-title"
}, "编辑可查询时间", -1));
const _hoisted_6 = {
  class: "popover-footer"
};
const _hoisted_7 = {
  class: "edit-icon"
};
import { message } from 'ant-design-vue';
import { EditOutlined } from '@ant-design/icons-vue';
import TimeRangeEditor from './TimeRangeEditor.vue';
import { useTimeRange, UNSET_TEXT } from '../hooks/useTimeRange';
export default /*#__PURE__*/_defineComponent({
  __name: 'QueryTimeCell',
  props: {
    product: null
  },
  emits: ["save"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      validateRanges,
      formatRange,
      formatQueryTime,
      formatRangeCount
    } = useTimeRange();
    const open = ref(false);
    const unlimited = ref(false);
    const ranges = ref([{
      startDate: '',
      endDate: ''
    }]);
    const displayText = computed(() => formatQueryTime(props.product.queryTimeMode, props.product.timeRanges));
    const countText = computed(() => formatRangeCount(props.product.queryTimeMode, props.product.timeRanges));
    const isUnset = computed(() => displayText.value === UNSET_TEXT);
    const resetFromProduct = () => {
      unlimited.value = props.product.queryTimeMode === 'unlimited';
      ranges.value = props.product.queryTimeMode === 'ranges' && props.product.timeRanges.length ? props.product.timeRanges.map(item => ({
        ...item
      })) : [{
        startDate: '',
        endDate: ''
      }];
    };
    const handleOpenChange = visible => {
      if (visible) {
        resetFromProduct();
      }
    };
    const handleCancel = () => {
      open.value = false;
    };
    const handleConfirm = () => {
      if (unlimited.value) {
        emit('save', {
          productId: props.product.productId,
          queryTimeMode: 'unlimited',
          timeRanges: []
        });
        open.value = false;
        return;
      }
      const result = validateRanges(ranges.value);
      if (!result.ok) {
        message.warning(result.message);
        return;
      }
      emit('save', {
        productId: props.product.productId,
        queryTimeMode: 'ranges',
        timeRanges: result.ranges || []
      });
      open.value = false;
    };
    return (_ctx, _cache) => {
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_popover = _resolveComponent("a-popover");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
        class: _normalizeClass(["display-text", {
          unset: _unref(isUnset)
        }])
      }, _toDisplayString(_unref(displayText)), 3), _unref(countText) ? (_openBlock(), _createBlock(_component_a_tooltip, {
        key: 0,
        placement: "top"
      }, {
        title: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.product.timeRanges, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, _toDisplayString(_unref(formatRange)(item)), 1);
        }), 128))]),
        default: _withCtx(() => [_createVNode(_component_a_tag, {
          class: "count-tag",
          color: "blue"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(countText)), 1)]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)]), _createVNode(_component_a_popover, {
        open: open.value,
        "onUpdate:open": _cache[2] || (_cache[2] = $event => open.value = $event),
        trigger: "click",
        placement: "bottomRight",
        onOpenChange: handleOpenChange
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_checkbox, {
          checked: unlimited.value,
          "onUpdate:checked": _cache[0] || (_cache[0] = $event => unlimited.value = $event)
        }, {
          default: _withCtx(() => [_createTextVNode("不限时间")]),
          _: 1
        }, 8, ["checked"])]), _createVNode(TimeRangeEditor, {
          modelValue: ranges.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ranges.value = $event),
          disabled: unlimited.value,
          "remove-style": "icon"
        }, null, 8, ["modelValue", "disabled"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_button, {
          size: "small",
          onClick: handleCancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          size: "small",
          type: "primary",
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        })])])]),
        default: _withCtx(() => [_createVNode(_component_a_tooltip, {
          title: "点击配置时间"
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_unref(EditOutlined))])]),
          _: 1
        })]),
        _: 1
      }, 8, ["open"])]);
    };
  }
});